import { useGet } from '../../../sharedModules/hooks/useQuery';
import { StatementDetail } from '../model';
import { STATEMENTS_URL } from './useStatements';

export function useStatement(acctNo: string, location: string, enabled = true) {
  return useGet<StatementDetail>({
    url: `${STATEMENTS_URL}/${acctNo}`,
    params: { location },
    enabled: enabled && Boolean(acctNo),
  });
}
